import Django_404_Template from "./django_components/Django_404_Template";
import Django_Add_Bootstrap5 from "./django_components/Django_Add_Bootstrap5";
import Django_Add_Global_Static_Files from "./django_components/Django_Add_Global_Static_Files";
import Django_Add_Link_To_Details from "./django_components/Django_Add_Link_To_Details";
import Django_Add_Main_Index_Page from "./django_components/Django_Add_Main_Index_Page";
import Django_Add_Master_Template from "./django_components/Django_Add_Master_Template";
import Django_Add_Members from "./django_components/Django_Add_Members";
import Django_Add_Members_PostgreSQL from "./django_components/Django_Add_Members_PostgreSQL";
import Django_Add_Slug_Field from "./django_components/Django_Add_Slug_Field";
import Django_Add_Static_Files from "./django_components/Django_Add_Static_Files";
import Django_Add_Styles_To_The_Project from "./django_components/Django_Add_Styles_To_The_Project";
import Django_Add_Test_View from "./django_components/Django_Add_Test_View";
import Django_Admin from "./django_components/Django_Admin";
import Django_Certificate from "./django_components/Django_Certificate";
import Django_Collect_Static_Files from "./django_components/Django_Collect_Static_Files";
import Django_Comment from "./django_components/Django_Comment";
import Django_Compiler from "./django_components/Django_Compiler";
import Django_Connect_To_Database from "./django_components/Django_Connect_To_Database";
import Django_Create_App from "./django_components/Django_Create_App";
import Django_Create_AWS_Account from "./django_components/Django_Create_AWS_Account";
import Django_Create_Config from "./django_components/Django_Create_Config";
import Django_Create_Database_In_RDS from "./django_components/Django_Create_Database_In_RDS";
import Django_Create_Project from "./django_components/Django_Create_Project";
import Django_Create_Requirements from "./django_components/Django_Create_Requirements";
import Django_Create_User from "./django_components/Django_Create_User";
import Django_Create_Virtual_Environment from "./django_components/Django_Create_Virtual_Environment";
import Django_Create_Zip_File from "./django_components/Django_Create_Zip_File";
import Django_Delete_Data from "./django_components/Django_Delete_Data";
import Django_Delete_Members from "./django_components/Django_Delete_Members";
import Django_Deploy_With_EB from "./django_components/Django_Deploy_With_EB";
import Django_Display_Data from "./django_components/Django_Display_Data";
import Django_Elastic_Beanstalk from "./django_components/Django_Elastic_Beanstalk";
import Django_Exercises from "./django_components/Django_Exercises";
import Django_Field_Lookups_Reference from "./django_components/Django_Field_Lookups_Reference";
import Django_Filter_Reference from "./django_components/Django_Filter_Reference";
import Django_For_Loop from "./django_components/Django_For_Loop";
import Django_Get_Started from "./django_components/Django_Get_Started";
import Django_Home from "./django_components/Django_Home";
import Django_If_Else from "./django_components/Django_If_Else";
import Django_Include from "./django_components/Django_Include";
import Django_Include_Models from "./django_components/Django_Include_Models";
import Django_Insert_Data from "./django_components/Django_Insert_Data";
import Django_Install from "./django_components/Django_Install";
import Django_Install_WhiteNoise from "./django_components/Django_Install_WhiteNoise";
import Django_Intro from "./django_components/Django_Intro";
import Django_Models from "./django_components/Django_Models";
import Django_PostgreSQL_Intro from "./django_components/Django_PostgreSQL_Intro";
import Django_Prep_Template_And_View from "./django_components/Django_Prep_Template_And_View";
import Django_QuerySet_Filter from "./django_components/Django_QuerySet_Filter";
import Django_QuerySet_Get from "./django_components/Django_QuerySet_Get";
import Django_QuerySet_Introduction from "./django_components/Django_QuerySet_Introduction";
import Django_QuerySet_Order_By from "./django_components/Django_QuerySet_Order_By";
import Django_Quiz from "./django_components/Django_Quiz";
import Django_Server from "./django_components/Django_Server";
import Django_Set_List_Display from "./django_components/Django_Set_List_Display";
import Django_Study_Plan from "./django_components/Django_Study_Plan";
import Django_Syllabus from "./django_components/Django_Syllabus";
import Django_Tags from "./django_components/Django_Tags";
import Django_Templates from "./django_components/Django_Templates";
import Django_Template_Tag_Reference from "./django_components/Django_Template_Tag_Reference";
import Django_Tutorial from "./django_components/Django_Tutorial";
import Django_Update_Data from "./django_components/Django_Update_Data";
import Django_Update_Members from "./django_components/Django_Update_Members";
import Django_Update_Model from "./django_components/Django_Update_Model";
import Django_Update_Project from "./django_components/Django_Update_Project";
import Django_URLs from "./django_components/Django_URLs";
import Django_Variables from "./django_components/Django_Variables";
import Django_Views from "./django_components/Django_Views";

const AllDjangoComponents = {
  "<Django_404_Template />": Django_404_Template,
  "<Django_Add_Bootstrap5 />": Django_Add_Bootstrap5,
  "<Django_Add_Global_Static_Files />": Django_Add_Global_Static_Files,
  "<Django_Add_Link_To_Details />": Django_Add_Link_To_Details,
  "<Django_Add_Main_Index_Page />": Django_Add_Main_Index_Page,
  "<Django_Add_Master_Template />": Django_Add_Master_Template,
  "<Django_Add_Members />": Django_Add_Members,
  "<Django_Add_Members_PostgreSQL />": Django_Add_Members_PostgreSQL,
  "<Django_Add_Slug_Field />": Django_Add_Slug_Field,
  "<Django_Add_Static_Files />": Django_Add_Static_Files,
  "<Django_Add_Styles_To_The_Project />": Django_Add_Styles_To_The_Project,
  "<Django_Add_Test_View />": Django_Add_Test_View,
  "<Django_Admin />": Django_Admin,
  "<Django_Certificate />": Django_Certificate,
  "<Django_Collect_Static_Files />": Django_Collect_Static_Files,
  "<Django_Comment />": Django_Comment,
  "<Django_Compiler />": Django_Compiler,
  "<Django_Connect_To_Database />": Django_Connect_To_Database,
  "<Django_Create_App />": Django_Create_App,
  "<Django_Create_AWS_Account />": Django_Create_AWS_Account,
  "<Django_Create_Config />": Django_Create_Config,
  "<Django_Create_Database_In_RDS />": Django_Create_Database_In_RDS,
  "<Django_Create_Project />": Django_Create_Project,
  "<Django_Create_Requirements />": Django_Create_Requirements,
  "<Django_Create_User />": Django_Create_User,
  "<Django_Create_Virtual_Environment />": Django_Create_Virtual_Environment,
  "<Django_Create_Zip_File />": Django_Create_Zip_File,
  "<Django_Delete_Data />": Django_Delete_Data,
  "<Django_Delete_Members />": Django_Delete_Members,
  "<Django_Deploy_With_EB />": Django_Deploy_With_EB,
  "<Django_Display_Data />": Django_Display_Data,
  "<Django_Elastic_Beanstalk />": Django_Elastic_Beanstalk,
  "<Django_Exercises />": Django_Exercises,
  "<Django_Field_Lookups_Reference />": Django_Field_Lookups_Reference,
  "<Django_Filter_Reference />": Django_Filter_Reference,
  "<Django_For_Loop />": Django_For_Loop,
  "<Django_Get_Started />": Django_Get_Started,
  "<Django_Home />": Django_Home,
  "<Django_If_Else />": Django_If_Else,
  "<Django_Include />": Django_Include,
  "<Django_Include_Models />": Django_Include_Models,
  "<Django_Insert_Data />": Django_Insert_Data,
  "<Django_Install />": Django_Install,
  "<Django_Install_WhiteNoise />": Django_Install_WhiteNoise,
  "<Django_Intro />": Django_Intro,
  "<Django_Models />": Django_Models,
  "<Django_PostgreSQL_Intro />": Django_PostgreSQL_Intro,
  "<Django_Prep_Template_And_View />": Django_Prep_Template_And_View,
  "<Django_QuerySet_Filter />": Django_QuerySet_Filter,
  "<Django_QuerySet_Get />": Django_QuerySet_Get,
  "<Django_QuerySet_Introduction />": Django_QuerySet_Introduction,
  "<Django_QuerySet_Order_By />": Django_QuerySet_Order_By,
  "<Django_Quiz />": Django_Quiz,
  "<Django_Server />": Django_Server,
  "<Django_Set_List_Display />": Django_Set_List_Display,
  "<Django_Study_Plan />": Django_Study_Plan,
  "<Django_Syllabus />": Django_Syllabus,
  "<Django_Tags />": Django_Tags,
  "<Django_Templates />": Django_Templates,
  "<Django_Template_Tag_Reference />": Django_Template_Tag_Reference,
  "<Django_Tutorial />": Django_Tutorial,
  "<Django_Update_Data />": Django_Update_Data,
  "<Django_Update_Members />": Django_Update_Members,
  "<Django_Update_Model />": Django_Update_Model,
  "<Django_Update_Project />": Django_Update_Project,
  "<Django_URLs />": Django_URLs,
  "<Django_Variables />": Django_Variables,
  "<Django_Views />": Django_Views,
};

export default AllDjangoComponents;
